import { TicketTaxModel } from './tickettax.model';

export class TicketLineModel {
  product: string;
  conceptUid: string;
  quantity: number;
  discount: number;
  unityAmount: number;
  position: number;
  totalLine: number;
  taxes: Array<TicketTaxModel>;

  constructor() {
    this.taxes = new Array<TicketTaxModel>();
    this.discount = 0;
    this.quantity = 1;
    this.unityAmount = 0;
  }
}
